module.exports = __webpack_public_path__ + "static/media/event.9487103a.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/event.png
// module id = 518
// module chunks = 0